<template>
  <div class="mx-auto" :style="estiloContenedorStepper">
    <div class="stepper" style="background-color: white; min-height: 5em; border-radius: 15px;">
      <div
          v-for="(etapa, index) in etapasOrdenadas"
          :key="index"
          :class="['step', claseEtapa(etapa, index)]"
          class="d-flex justify-content-between mr-3 ml-3"
      >
        <div class="d-flex align-items-center flex-column">
          <div class="d-flex">
            <div
                v-if="index >= indiceEtapaActual && !indicesErroresEtapa.includes(index) && !(etapa.idEtapa === 108 && etapaActual === 108)"
                class="step-number">{{ index + 1 }}
            </div>
            <div v-else-if="indicesErroresEtapa.includes(index)" class="step-number"><em
                class="exclamation icons-size"></em></div>
            <div v-else-if="indicesErroresEtapa.includes(index + 1)" class="step-number error"><em
                class="exclamation icons-size"></em></div>
            <div v-else class="step-number"><em class="check"></em></div>
            <div class="step-label ml-2">{{ etapa.nombreEtapa }}</div>
          </div>
          <div style="height: 1em;">
            <p
                class="date"
                v-if="etapa.fechaFin && etapa.esValida &&
                          (index !== indiceEtapaActual ||
                          (etapa.idEtapa === etapaActual && (etapa.idEtapa === 109 || etapa.idEtapa === 110 || etapa.idEtapa === 108)))"
            >
              {{ etapa.fechaFin | formatoFechaHora }} <span v-if="etapa.idEtapa === 108">(Tiempo final: {{calculoDiasTardo()}})</span>
            </p>
            <p
                class="date"
                v-if="etapa.idEtapa === etapaActual && (etapa.idEtapa !== 109 && etapa.idEtapa !== 110 && etapa.idEtapa !== 108) "
            >
              {{ etapa.fechaInicio | formatoFechaHora }}
            </p>

          </div>
        </div>
        <div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "StepperEtapas",
  components: {},
  props: {
    etapaActual: Number,
    etapas: Array,
    etapasLaboratorio: Array,
    esFlujoDigital: Boolean,
  },
  data() {
    return {
      rechazoMesaIngreso: false,
      rechazoCalidad: false,

    }
  },
  created() {

  },
  computed: {
    indiceEtapaActual() {
      return this.etapasOrdenadas.findIndex(e => e.idEtapa === this.etapaActual);
    },
    etapasOrdenadas() {
      const ordenBase = this.etapasBase(this.esFlujoDigital);
      const etapasMap = new Map(this.etapasLaboratorio.map(e => [e.idEtapaProceso, e]));
      const resultado = [];

      // Obtener etapaMaximaAlcanzada aquí
      const etapasConFecha = this.etapasLaboratorio
          .filter(e => e.fechaFin)
          .map(e => ({...e, fechaFin: new Date(e.fechaFin)}));
      etapasConFecha.sort((a, b) => b.fechaFin - a.fechaFin);
      const etapaMaxima = etapasConFecha.length > 0 ? etapasConFecha[0].idEtapaProceso : null;

      for (const etapaBase of ordenBase) {
        const etapaLab = etapasMap.get(etapaBase.idEtapa);

        const esValida = etapaBase.idEtapa <= etapaMaxima || etapaBase.idEtapa === 109 || etapaBase.idEtapa === 110 || etapaBase.idEtapa === 108;

        resultado.push({
          idEtapa: etapaBase.idEtapa,
          nombreEtapa: etapaBase.nombreEtapa,
          fechaFin: etapaLab ? etapaLab.fechaFin : null,
          fechaInicio: etapaLab ? etapaLab.fechaInicio : null,
          esValida // <-- agrega esta propiedad
        });

        // Rechazos (igual que antes)
        if (etapaBase.idEtapa === 104) {
          const rechazoMesa = etapasMap.get(109);
          if (rechazoMesa) {
            resultado.push({
              idEtapa: 109,
              nombreEtapa: 'Rechazo Mesa de Ingreso',
              fechaFin: rechazoMesa.fechaFin,
              esValida: true,
            });
          }
        }
        if (etapaBase.idEtapa === 105) {
          const rechazoCalidad = etapasMap.get(110);
          if (rechazoCalidad) {
            resultado.push({
              idEtapa: 110,
              nombreEtapa: 'Rechazo Calidad',
              fechaFin: rechazoCalidad.fechaFin,
              esValida: true,
            });
          }
        }
      }

      return resultado;
    },


    indicesErroresEtapa() {
      return this.etapasOrdenadas
          .map((etapa, index) => ({id: etapa.idEtapa, index}))
          .filter(e => e.id === 109 || e.id === 110)
          .map(e => e.index);
    },
    estiloContenedorStepper() {
      const tieneEtapasExtra = this.etapasOrdenadas.length > 6;
      return {
        display: 'inline-block',
        margin: '0 auto',
        width: 'max-content',
        'max-width': '97vw',
        'min-width': tieneEtapasExtra ? '97vw' : '70vw'
      };
    },
    etapaMaximaAlcanzada() {
      // Filtramos etapas con fechaFin
      const etapasConFecha = this.etapasLaboratorio
          .filter(e => e.fechaFin)
          .map(e => ({...e, fechaFin: new Date(e.fechaFin)}));

      // Ordenamos por fechaFin descendente
      etapasConFecha.sort((a, b) => b.fechaFin - a.fechaFin);

      // Devolvemos la etapa con la fechaFin más reciente
      return etapasConFecha.length > 0 ? etapasConFecha[0].idEtapaProceso : null;
    }

  },

  methods: {
    etapasBase(esDigital = true) {
      const todasLasEtapas = [
        {idEtapa: 103, nombreEtapa: "En tránsito a lab"},
        {idEtapa: 104, nombreEtapa: "Mesa de ingreso"},
        {idEtapa: 105, nombreEtapa: "Calidad"},
        {idEtapa: 106, nombreEtapa: "Producción"},
        {idEtapa: 107, nombreEtapa: "Retorno a clínica"},
        {idEtapa: 108, nombreEtapa: "Completado"}
      ];

      if (esDigital) {
        return todasLasEtapas.filter(etapa => etapa.idEtapa !== 103);
      }

      return todasLasEtapas;
    },

    claseEtapa(etapa, index) {
      const esError = this.indicesErroresEtapa.includes(index);
      const esAnteriorDeError = this.indicesErroresEtapa.includes(index + 1);

      if (esError || esAnteriorDeError) return 'error';

      const etapaLab = this.etapasLaboratorio.find(
          e => e.idEtapaProceso === etapa.idEtapa && e.fechaFin
      );

      const etapaMaxima = this.etapaMaximaAlcanzada;

      // Si es la etapa actual y está dentro del flujo lógico
      if (etapa.idEtapa === this.etapaActual && etapa.idEtapa === etapaMaxima && etapa.idEtapa !== 108  && this.etapaActual !== 108) {
        return 'active';
      }

      // Solo marcar como completed si es anterior o igual a la etapa con fechaFin más reciente
      if (etapaLab && etapa.idEtapa !== this.etapaActual && etapa.idEtapa <= etapaMaxima) {
        return 'completed';
      }

      // Si es completado oficialmente
      if (etapa.idEtapa === 108 && this.etapaActual === 108) {
        return 'completed';
      }

      return 'pending';
    },

    calculoDiasTardo(){
      const etapa103 = this.etapasLaboratorio.find(
          e => e.idEtapaProceso === 103 && e.fechaFin
      );

      const etapa104 = !etapa103
          ? this.etapasLaboratorio.find(
              e => e.idEtapaProceso === 104 && e.fechaFin
          )
          : null;

      const etapa108 = this.etapasLaboratorio.find(
          e => e.idEtapaProceso === 108 && e.fechaFin
      );

      const etapaInicial = etapa103 || etapa104;

      const fechaInicio = this.$moment(etapaInicial.fechaFin).startOf('day');
      const fechaFin = this.$moment(etapa108.fechaFin).startOf('day');

      return `${fechaFin.diff(fechaInicio, 'days')}d`
    }


  }
};
</script>

<style>
.stepper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
}

.step {
  display: flex;
  align-items: center;
  gap: 0.5em;
  color: #ccc;
  font-weight: 500;
}

.step-number {
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  border: 2px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9em;
}

.step-label {
  white-space: nowrap;
  font-size: 0.85em;
}

.step.active {
  color: #0056b3;
}

.step.active .step-number {
  border-color: #0056b3;
  color: #0056b3;
  font-weight: bold;
}

.step.completed {
  color: #28a745;
}

.step.error {
  color: #DE6F6F;
}

.step.completed .step-number {
  border-color: #28a745;
  color: #28a745;
}

.step.error .step-number {
  border-color: #DE6F6F;
  color: #DE6F6F;
}

.step.pending {
  color: #bbb;
}

.step.pending .step-number {
  border-color: #ccc;
  color: #ccc;
}

.date {
  color: #656565;
  text-align: center;
  font-size: .8em;
}

</style>
